import {
  Github,
  Globe,
  Instagram,
  Linkedin,
  Mail,
  MessageCircle,
  Phone,
  Twitter,
  Youtube,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  github: Github,
  linkedin: Linkedin,
  mail: Mail,
  email: Mail,
  twitter: Twitter,
  x: Twitter,
  instagram: Instagram,
  youtube: Youtube,
  discord: MessageCircle,
  whatsapp: Phone,
  phone: Phone,
  website: Globe,
};

export function SocialIcon({ iconKey, className }: { iconKey: string; className?: string }) {
  const Icon = ICONS[iconKey.toLowerCase()] ?? Globe;
  return <Icon className={className} aria-hidden />;
}
